import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import { Container, Row, Col } from 'react-bootstrap';
import API from '../Utils/Api';

function Footer(props) {

    const [inputs, setInputs] = useState({facebook:'',youtube:'',instagram:''});

    useEffect(() => {            
            API.post('get_settings')
                .then(response => {
                    
                    if (response.data.status === false) {

                    } else {
                        setInputs({
                            facebook:response.data.data.facebook,
                            youtube:response.data.data.youtube,
                            instagram:response.data.data.instagram
                        });
                    }
                }).catch(error => {
                    
                });
        }, []);

    return (
        <>
            <section className="footer">
                <Container>
                    <Row>
                        <Col md={3} sm={6} xs={6}>
                            <h4>General</h4>
                            <ul>
                                <li>
                                    <Link to="/privacy">Privacy Policy</Link>
                                </li>
                                <li>
                                    <Link to="/terms">Terms and Conditions</Link>
                                </li>
                                <li>
                                    <Link to="/customer-support">Customer Support</Link>
                                </li>
                                <li>
                                    <Link to="/press">Press</Link>
                                </li>
                                <li>
                                    <Link to="/contact-us">Contact Us</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col md={3} sm={6} xs={6}>
                            <h4>Know More</h4>
                            <ul>
                                <li>
                                    <Link to="/about">About LocalBells</Link>
                                </li>
                                <li>
                                    <Link to="/how-it-works">How It Works</Link>
                                </li>
                                {/*<li>
                                    <Link to="">Blogs</Link>
                                </li>*/}
                                <li>
                                    <Link to="/help-center">FAQ</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col md={3} sm={6} xs={6}>
                            <h4>Local Business</h4>
                            <ul>
                                <li>
                                    <Link to="/advertisement">Advertisement on LocalBells</Link>
                                </li>
                                <li>
                                    <Link to="/register-business">Register Business on LoccalBells</Link>
                                </li>
                            </ul>
                        </Col>
                        <Col md={3} sm={6} xs={6}>
                            <h4>Join us</h4>
                            <ul>
                                <li>
                                    <Link to="/affiliate-partnership">Affiliate Partnership</Link>
                                </li>
                                <li>
                                    <Link to="/career">Career</Link>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                    <Row className='footer-bot'>
                        <Col xs={6} sm={6}>
                            <p>© 2025 LocalBells. All rights reserved.</p>
                        </Col>
                        <Col xs={6} sm={6}>
                            <div>
                                <Link to={inputs.facebook}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/fb.webp'} className="img-fluid" alt="fb" /></Link>
                                <Link to={inputs.instagram}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/insta.webp'} className="img-fluid" alt="insta" /></Link>
                                <Link to={inputs.youtube}><Image src={process.env.REACT_APP_BASE_URL + 'assets/images/youtube.webp'} className="img-fluid" alt="youtube" /></Link>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}
export default Footer;